import { buildRouteTree } from "utils/routeUtils";

export const routes = buildRouteTree({
	invitation: {
		acceptAs: null
	}
});
